import * as actionTypes from '../actions/chart';
import { charts } from '../utils/constants';

const initialState = {
  fetching: false,
  charts
};

const chartReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CHARTS_INFO_SUCCESS: {
      const newCharts = { ...state.charts };
      newCharts.lists.forEach(list => {
        if (list.id === action.payload.id) {
          list.dataParams = action.payload.dataParams;
          list.ready = true;
        }
      });
      return {
        ...state,
        charts: newCharts,
        fetching: false,
        currentlyFetchingId: ''
      };
    }
    case actionTypes.FETCH_CHARTS_INFO_FAILURE:
      return {
        ...state,
        fetching: false,
        currentlyFetchingId: ''
      };
    default: {
      return state;
    }
  }
};

export default chartReducer;
